export function detectAndroidMob() {
    const toMatch = [
        /Android/i
    ];

    return toMatch.some((toMatchItem) => {
        return navigator.userAgent.match(toMatchItem);
    });
}

export function detectAndroidMobile() {
    return navigator.userAgent.match(/HSPORTALAPP-ANDROID/i);
}
